import styled from "@emotion/styled";

import { IconButton, PrefixChip, SkiliticsIcon } from "@skilitics/designer-ui-components";

const StyledPrefixChip = styled(PrefixChip)`
  display: flex;
  align-items: center;
  justify-content: center;

  clip-path: border-box;

  > span {
    padding: 0;
  }
`;

const Button = styled(IconButton)`
  height: 20px;
  width: auto;
  padding: 0 1px 0 2px;

  color: inherit;

  border-radius: 0;

  cursor: pointer;
  pointer-events: auto;
`;

const Separator = styled.div`
  width: 1px;
  align-self: stretch;
  background-color: ${({ theme }) => theme.surface};
`;

const Container = styled.div`
  display: flex;
  align-items: center;

  width: 100%;

  pointer-events: none;
`;

const Title = styled.div`
  padding: 0 8px 0 6px;
`;

export type EventConditionChipProps = {
  title: string;
  open?: (element: HTMLElement) => void;
};

export const EventConditionChip = ({ title, open }: EventConditionChipProps) => {
  const handleClick = (event: React.MouseEvent<HTMLElement>) => {
    event.stopPropagation();
    open?.(event.currentTarget);
  };

  return (
    <StyledPrefixChip
      label={
        <Container>
          <Button onClick={handleClick} data-test="configure-event">
            <SkiliticsIcon icon="advanced-settings" size={16} />
          </Button>
          <Separator />
          <Title>{title}</Title>
        </Container>
      }
      type="tertiary"
    />
  );
};
